export function sanitizePostHogId(value?: string | null): string {
  if (!value) {
    return "";
  }

  const normalizedValue = value.trim();
  if (
    !normalizedValue ||
    normalizedValue === "undefined" ||
    normalizedValue === "null"
  ) {
    return "";
  }

  return normalizedValue;
}
